import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Card, Form, Input, Select, Button, message } from 'antd';
import { useMutation } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';
import { ticketsApi } from '../../services/api';

const { TextArea } = Input;

export default function CreateTicketPage() {
  const { t } = useTranslation('support');
  const navigate = useNavigate();
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);

  const createMutation = useMutation({
    mutationFn: ticketsApi.createTicket,
    onSuccess: () => {
      message.success(t('create_page.success'));
      navigate('/support');
    },
    onError: (error: any) => {
      message.error(error.response?.data?.message || t('create_page.failed'));
    },
  });

  const handleSubmit = async (values: any) => {
    setLoading(true);
    try {
      await createMutation.mutateAsync(values);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div>
      <h1 style={{ marginBottom: 24, fontSize: 24, fontWeight: 600 }}>{t('create_page.title')}</h1>

      <Card>
        <Form
          form={form}
          layout="vertical"
          onFinish={handleSubmit}
          initialValues={{
            priority: 'medium',
          }}
        >
          <Form.Item
            label={t('create_page.subject')}
            name="subject"
            rules={[{ required: true, message: t('create_page.subject_required') }]}
          >
            <Input placeholder={t('create_page.subject_placeholder')} />
          </Form.Item>

          <Form.Item
            label={t('create_page.description')}
            name="description"
            rules={[{ required: true, message: t('create_page.description_required') }]}
          >
            <TextArea
              rows={6}
              placeholder={t('create_page.description_placeholder')}
            />
          </Form.Item>

          <Form.Item label={t('create_page.priority')} name="priority">
            <Select>
              <Select.Option value="low">{t('priority.low')}</Select.Option>
              <Select.Option value="medium">{t('priority.medium')}</Select.Option>
              <Select.Option value="high">{t('priority.high')}</Select.Option>
              <Select.Option value="urgent">{t('priority.urgent')}</Select.Option>
            </Select>
          </Form.Item>

          <Form.Item label={t('create_page.category')} name="category">
            <Select placeholder={t('create_page.category_placeholder')} allowClear>
              <Select.Option value="technical">{t('create_page.category_technical')}</Select.Option>
              <Select.Option value="account">{t('create_page.category_account')}</Select.Option>
              <Select.Option value="billing">{t('create_page.category_billing')}</Select.Option>
              <Select.Option value="feature">{t('create_page.category_feature')}</Select.Option>
              <Select.Option value="other">{t('create_page.category_other')}</Select.Option>
            </Select>
          </Form.Item>

          <Form.Item>
            <Button type="primary" htmlType="submit" loading={loading} style={{ marginRight: 8 }}>
              {t('create_page.submit')}
            </Button>
            <Button onClick={() => navigate('/support')}>{t('common:cancel')}</Button>
          </Form.Item>
        </Form>
      </Card>
    </div>
  );
}
